import { getAllOptionsAreSamePrice } from './getAllOptionsAreSamePrice.mjs';
import { getPriceBreakdown } from './getPriceBreakdown.mjs';

function getPriceInfo(wranglerPriceData, wranglerContext, data) {
    const { fractionDigits, currency } = wranglerPriceData;
    const { includeVat = false, culture } = wranglerContext;
    const allOptionsAreSamePrice = getAllOptionsAreSamePrice(data.attributes);
    return {
        // Duplicate all this stuff for each of the quantity values so that they'll be in the format that RawPrice and UnitPrice
        // take; this should make it a tiny bit easier to override price rendering.
        quantities: (data.quantities?.quantities ?? []).map(({ quantity, totalListPrice, totalDiscountedPrice, unitListPrice, unitDiscountedPrice, badges }) => ({
            quantity,
            culture,
            currency,
            listPrice: totalListPrice,
            discountPrice: totalDiscountedPrice,
            unitListPrice,
            unitDiscountPrice: unitDiscountedPrice,
            badges,
            vatInc: includeVat,
            minimumFractionDigits: fractionDigits,
            hideVatMessage: false,
        })),
        culture,
        currency,
        vatInc: includeVat,
        minimumFractionDigits: fractionDigits,
        priceBreakdown: getPriceBreakdown(data),
        pricesBreakdownArray: data.price.breakdown,
        allOptionsAreSamePrice,
        hideVatMessage: false,
    };
}

export { getPriceInfo };
//# sourceMappingURL=getPriceInfo.mjs.map
